module.exports = __webpack_public_path__ + "static/media/YoungMan.63fac3f8.png";